import {
    type DroppableOverData,
    type DroppableOverDataDelimiterWithNode,
    type DroppableOverDataDelimiterWithoutNode,
    type DroppableOverDataNode,
} from './types';

export function isDroppableOverData<Attributes extends unknown>(data: unknown): data is DroppableOverData<Attributes> {
    return (
        typeof data === 'object' &&
        data !== null &&
        'type' in data &&
        (data.type === 'node' || data.type === 'delimiter')
    );
}

export function isDroppableOverDataDelimiterWithNode<Attributes extends unknown>(
    data: unknown
): data is DroppableOverDataDelimiterWithNode<Attributes> {
    return isDroppableOverData(data) && data.type === 'delimiter' && data.node !== undefined;
}

export function isDroppableOverDataDelimiterWithoutNode(data: unknown): data is DroppableOverDataDelimiterWithoutNode {
    return isDroppableOverData(data) && data.type === 'delimiter' && data.node === undefined;
}

export function isDroppableOverDataNode<Attributes extends unknown>(
    data: unknown
): data is DroppableOverDataNode<Attributes> {
    return isDroppableOverData(data) && data.type === 'node' && data.node !== undefined;
}
